import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
    <ol className="flex flex-wrap items-center gap-1.5">
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <li key={c.path} className={`flex items-center gap-1.5 min-w-0 ${last && items.length > 2 ? "hidden sm:flex" : ""}`}>
            {i > 0 && <ChevronRight className="h-3 w-3 shrink-0 text-slate-600" />}
            {last ? (
              <span aria-current="page" data-testid="breadcrumb-current" className="text-slate-300 truncate max-w-[60vw] sm:max-w-md">{c.name}</span>
            ) : (
              <Link to={c.path} data-testid={`breadcrumb-${i}`} className="text-sky-400 hover:text-sky-300">{c.name}</Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
